import React, { useState } from "react";
import { FormSection } from "./Form";
import {
  FormOutlined,
  UnorderedListOutlined,
  ReloadOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import { Button, Tabs } from "antd";
import { Col, Row } from "reactstrap";
import BasicGrid from "./Grid";
import { FilterMode } from "./Filtermode";
import { useBarCodeMasterStore } from "../../../store/useBarCodeStore";

const BarCodeLiquidationMaster = () => {
  const {
    mode,
    toggleMode,
    setMode,
    submitEditRow,
    editRow,
    resetEdit,
    resetEditCompletely,
  } = useBarCodeMasterStore();
  const isEditMode = !!editRow?.Id;

  const items = [
    {
      key: "view",
      label: "View Records",
    },
    {
      key: "edit",
      label: "Add / Edit Form",
    },
  ];

  return (
    <>
      <Row style={{ marginTop: "0.5rem", marginBottom: "1rem" }}>
        <Col>
          <Tabs
            items={items}
            activeKey={mode ? "edit" : "view"}
            onChange={(key) => {
              if (mode && key === "view") {
                resetEditCompletely(); 
              } else {
                setMode(key === "edit");
              }
            }}
            type="card"
            size="large"
          />
        </Col>
      </Row>
      {mode && (
        <Row
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Col
            xl={{ size: 3, offset: 7 }}
            md={{ size: 8 }}
            sm={{ size: 12 }}
            xs={{ size: 20 }}
            style={{ textAlign: "center" }}
          >
            <Button
              type="primary"
              icon={<SaveOutlined />}
              size="large"
              style={{
                marginRight: "0.75rem",
                backgroundColor: "#52c41a", // elegant green
                borderColor: "#52c41a",
                boxShadow: "0 2px 6px rgba(82, 196, 26, 0.3)",
              }}
              onClick={submitEditRow}
            >
              {isEditMode ? "Update" : "Submit"}
            </Button>

            <Button
              icon={<ReloadOutlined />}
              size="large"
              style={{
                borderColor: "#ff1818ff",
                color: "#ff1818ff",
              }}
              onClick={resetEdit}
            >
              Reset
            </Button>
          </Col>
        </Row>
      )}
      {!mode && <FilterMode />}
      {mode ? <FormSection /> : <BasicGrid />}
    </>
  );
};

export default BarCodeLiquidationMaster;
